import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Button, {
  buttonTypes,
  buttonSizes,
  buttonTextSizes,
  buttonFunctions,
} from '../../shared/Button';
import {
  submitText,
  cancelText,
  descriptionText,
  phoneText,
  notesText,
} from '../../shared/SharedInternationalizations';
import InlineHelpText from '../../shared/InlineHelpText';
import HelpIcon from '../../shared/HelpIcon';
import { required } from '../../../utilities/general';

export function UnconnectedAddEditMassNotification(props) {
  const { deviceDetails, deviceType, onSubmit } = props;

  // Help text states
  const [showDescriptionHelpText, setShowDescriptionHelpText] = useState(false);
  const descriptionHelpTextRef = useRef();
  function toggleDescriptionHelpText(value) {
    setShowDescriptionHelpText(value);
  }
  const descriptionHelpText = (
    <FormattedMessage
      id="addEditMassNotification.descriptionHelpText"
      defaultMessage="The description for this mass notification device."
      description="Help text."
    />
  );

  const [showWorkPhoneHelpText, setShowWorkPhoneHelpText] = useState(false);
  const workPhoneHelpTextRef = useRef();
  function toggleWorkPhoneHelpText(value) {
    setShowWorkPhoneHelpText(value);
  }
  const workPhoneHelpText = (
    <FormattedMessage
      id="addEditMassNotification.workPhoneHelpText"
      defaultMessage="Work phone number for mass notification."
      description="Help text."
    />
  );

  const [showPrimaryPhoneHelpText, setShowPrimaryPhoneHelpText] = useState(false);
  const primaryPhoneHelpTextRef = useRef();
  function togglePrimaryPhoneHelpText(value) {
    setShowPrimaryPhoneHelpText(value);
  }
  const primaryPhoneHelpText = (
    <FormattedMessage
      id="addEditMassNotification.primaryPhoneHelpText"
      defaultMessage="Primary phone number for mass notification."
      description="Help text."
    />
  );
  const [showSecondaryPhoneHelpText, setShowSecondaryPhoneHelpText] = useState(false);
  const secondaryPhoneHelpTextRef = useRef();
  function toggleSecondaryPhoneHelpText(value) {
    setShowSecondaryPhoneHelpText(value);
  }
  const secondaryPhoneHelpText = (
    <FormattedMessage
      id="addEditMassNotification.secondaryPhoneHelpText"
      defaultMessage="Secondary phone number for mass notification."
      description="Help text."
    />
  );
  const [showTextPhoneHelpText, setShowTextPhoneHelpText] = useState(false);
  const textPhoneHelpTextRef = useRef();
  function toggleTextPhoneHelpText(value) {
    setShowTextPhoneHelpText(value);
  }
  const textPhoneHelpText = (
    <FormattedMessage
      id="addEditMassNotification.textPhoneHelpText"
      defaultMessage="Text message number for mass notification."
      description="Help text."
    />
  );

  const [showWorkEmailHelpText, setShowWorkEmailHelpText] = useState(false);
  const workEmailHelpTextRef = useRef();
  function toggleWorkEmailHelpText(value) {
    setShowWorkEmailHelpText(value);
  }
  const workEmailHelpText = (
    <FormattedMessage
      id="addEditMassNotification.workEmailHelpText"
      defaultMessage="Work email address for mass notification."
      description="Help text."
    />
  );
    const [showPersonalEmailHelpText, setShowPersonalEmailHelpText] = useState(false);
    const personalEmailHelpTextRef = useRef();
    function togglePersonalEmailHelpText(value) {
      setShowPersonalEmailHelpText(value);
    }
  const personalEmailHelpText = (
    <FormattedMessage
      id="addEditMassNotification.personalEmailHelpText"
      defaultMessage="Personal email address for mass notification."
      description="Help text."
    />
  );
    const [showSecondaryEmailHelpText, setShowSecondaryEmailHelpText] = useState(false);
    const secondaryEmailHelpTextRef = useRef();
    function toggleSecondaryEmailHelpText(value) {
      setShowSecondaryEmailHelpText(value);
    }
  const secondaryEmailHelpText = (
    <FormattedMessage
      id="addEditMassNotification.secondaryEmailHelpText"
      defaultMessage="Secondary email address for mass notification."
      description="Help text."
    />
  );

  const [showNotesHelpText, setShowNotesHelpText] = useState(false);
  const notesHelpTextRef = useRef();
  function toggleNotesHelpText(value) {
    setShowNotesHelpText(value);
  }
  const notesHelpText = (
    <FormattedMessage
      id="addEditMassNotification.notesHelpText"
      defaultMessage="Notes about this mass notification device."
      description="Help text."
    />
  );


  let details = {};

  if (!deviceDetails) {
    details = {
      alert_device_type: deviceType || 54, // Mass notification type
      user: '',
    };
  } else {
    details = {
      alert_device_id: deviceDetails.alert_device_id,
      alert_description: deviceDetails.alert_description || '',
      primary_phone: deviceDetails.primary_phone || '',
      work_phone: deviceDetails.work_phone || '',
      text_phone: deviceDetails.text_phone || '',
      secondary_phone: deviceDetails.secondary_phone || '',
      work_email: deviceDetails.work_email || '',
      personal_email: deviceDetails.personal_email || '',
      secondary_email: deviceDetails.secondary_email || '',
      notes: deviceDetails.notes || '',
      alert_device_type: deviceDetails.alert_device_type || 54,
      user: deviceDetails.user || '',
    };
  }
//   console.log('AddEditMassNotification - final details:', details);
  return (
    <React.Fragment>
      <Form
        data-test="add-edit-mass-notification-form"
        onSubmit={onSubmit}
        keepDirtyOnReinitialize={true}
        initialValues={{ ...details }}
        render={({
          handleSubmit,
          pristine,
          invalid,
          reset,
          submitting,
          values,
        }) => (
          <form
            onSubmit={handleSubmit}
            className="associate-users-units__form-container">
            
            <Field
              className="visually-hidden"
              name="user"
              component="input"
              type="text"
            />
            <Field
              className="visually-hidden"
              name="alert_device_type"
              component="input"
              type="number"
            />

            <div className="content-display__container">
              {/* Description Field */}
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label
                      className="text-large text-light text-deep-blue form-item__field-message--required"
                      htmlFor="alert_description">
                      {descriptionText}:
                    </label>
                    <Field
                      className="form-item__field"
                      name="alert_description"
                      component="input"
                      type="text"
                      validate={required}>
                      {({ input, meta }) => (
                        <React.Fragment>
                          <input
                            {...input}
                            type="text"
                            className={
                              meta.error && meta.touched
                                ? 'form-item__field form-item__field--error'
                                : 'form-item__field'
                            }
                          />
                          {meta.error && meta.touched && (
                            <span className="form-item__field-message--required text-small">
                              {meta.error}
                            </span>
                          )}
                        </React.Fragment>
                      )}
                    </Field>
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() =>
                        descriptionHelpTextRef.current.toggleHelpText()
                      }
                      toggled={showDescriptionHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={descriptionHelpTextRef}
                  toggleFunction={toggleDescriptionHelpText}
                  message={descriptionHelpText}
                />
              </div>

               <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <FormattedMessage
                        id="addEditMassNotification.primaryPhoneLabel"
                        defaultMessage="Primary Phone:"
                        description="Primary phone number label"
                      />
                    </label>
                    <Field
                      className="form-item__field"
                      name="primary_phone"
                      component="input"
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+">
                      {({ input, meta }) => (
                        <React.Fragment>
                          <input
                            {...input}
                            type="tel"
                            pattern="[0-9:,;#\-()\s]+"
                            className="form-item__field--noInvalid"
                          />
                        </React.Fragment>
                      )}
                    </Field>
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => primaryPhoneHelpTextRef.current.toggleHelpText()}
                      toggled={showPrimaryPhoneHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={primaryPhoneHelpTextRef}
                  toggleFunction={togglePrimaryPhoneHelpText}
                  message={primaryPhoneHelpText}
                />
              </div>

              {/* Work Phone */}
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <FormattedMessage
                        id="addEditMassNotification.workPhoneLabel"
                        defaultMessage="Work Phone:"
                        description="Work phone number label"
                      />
                    </label>
                    <Field
                      className="form-item__field"
                      name="work_phone"
                      component="input"
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+">
                      {({ input, meta }) => (
                        <React.Fragment>
                          <input
                            {...input}
                            type="tel"
                            pattern="[0-9:,;#\-()\s]+"
                            className="form-item__field--noInvalid"
                          />
                        </React.Fragment>
                      )}
                    </Field>
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => workPhoneHelpTextRef.current.toggleHelpText()}
                      toggled={showWorkPhoneHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={workPhoneHelpTextRef}
                  toggleFunction={toggleWorkPhoneHelpText}
                  message={workPhoneHelpText}
                />
              </div>

              {/* Text Phone */}
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <FormattedMessage
                        id="addEditMassNotification.textPhoneLabel"
                        defaultMessage="Text Message:"
                        description="Text phone number label"
                      />
                    </label>
                    <Field
                      className="form-item__field"
                      name="text_phone"
                      component="input"
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+"
                    />
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => textPhoneHelpTextRef.current.toggleHelpText()}
                      toggled={showTextPhoneHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={textPhoneHelpTextRef}
                  toggleFunction={toggleTextPhoneHelpText}
                  message={textPhoneHelpText}
                />
              </div>

              {/* Secondary Phone */}
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <FormattedMessage
                        id="addEditMassNotification.secondaryPhoneLabel"
                        defaultMessage="Secondary Phone:"
                        description="Secondary phone number label"
                      />
                    </label>
                    <Field
                      className="form-item__field"
                      name="secondary_phone"
                      component="input"
                      type="tel"
                      pattern="[0-9:,;#\-()\s]+"
                    />
                  </div>

                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => secondaryPhoneHelpTextRef.current.toggleHelpText()}
                      toggled={showSecondaryPhoneHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={secondaryPhoneHelpTextRef}
                  toggleFunction={toggleSecondaryPhoneHelpText}
                  message={secondaryPhoneHelpText}
                />
              </div>

              {/* Work Email */}
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <FormattedMessage
                        id="addEditMassNotification.workEmailLabel"
                        defaultMessage="Work Email:"
                        description="Work email label"
                      />
                    </label>
                    <Field
                      className="form-item__field"
                      name="work_email"
                      component="input"
                      type="email"
                    />
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => workEmailHelpTextRef.current.toggleHelpText()}
                      toggled={showWorkEmailHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={workEmailHelpTextRef}
                  toggleFunction={toggleWorkEmailHelpText}
                  message={workEmailHelpText}
                />
              </div>

              {/* Personal Email */}
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <FormattedMessage
                        id="addEditMassNotification.personalEmailLabel"
                        defaultMessage="Personal Email:"
                        description="Personal email label"
                      />
                    </label>
                    <Field
                      className="form-item__field"
                      name="personal_email"
                      component="input"
                      type="email"
                    />
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => personalEmailHelpTextRef.current.toggleHelpText()}
                      toggled={showPersonalEmailHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                  <InlineHelpText
                    ref={personalEmailHelpTextRef}
                    toggleFunction={togglePersonalEmailHelpText}
                    message={personalEmailHelpText}
                  />
                </div>
              </div>

              {/* Secondary Email */}
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      <FormattedMessage
                        id="addEditMassNotification.secondaryEmailLabel"
                        defaultMessage="Secondary Email:"
                        description="Secondary email label"
                      />
                    </label>
                    <Field
                      className="form-item__field"
                      name="secondary_email"
                      component="input"
                      type="email"
                    />
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => secondaryEmailHelpTextRef.current.toggleHelpText()}
                      toggled={showSecondaryEmailHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                  <InlineHelpText
                    ref={secondaryEmailHelpTextRef}
                    toggleFunction={toggleSecondaryEmailHelpText}
                    message={secondaryEmailHelpText}
                  />
                </div>
              </div>

              {/* Notes */}
              <div className="content-display__column content-display__column--1-2">
                <div className="content-display__item-container">
                  <div className="item-container__main-container">
                    <label className="text-large text-light text-deep-blue">
                      {notesText}:
                    </label>
                    <Field
                      className="form-item__field text-bold"
                      name="notes"
                      component="textarea"
                    />
                  </div>
                  <div className="item-container__info-container">
                    <HelpIcon
                      onClick={() => notesHelpTextRef.current.toggleHelpText()}
                      toggled={showNotesHelpText}
                      styles="margin-left-5"
                    />
                  </div>
                </div>
                <InlineHelpText
                  ref={notesHelpTextRef}
                  toggleFunction={toggleNotesHelpText}
                  message={notesHelpText}
                />
              </div>
            </div>

            <div className="width-100 margin-bottom-10"></div>
            <div className="form__section-container form__section-container--spread associate-users-units__form-buttons-container">
              <div className="form__items-group-container" />
              <div className="form__items-group-container">
                <Link
                  className="link link-text"
                  to={props.previous}
                  data-test="add-edit-mass-notification-form-cancel-link">
                  {cancelText}
                </Link>
                <Button
                  buttonFunction={buttonFunctions.submit}
                  text={submitText}
                  buttonType={buttonTypes.success}
                  buttonSize={buttonSizes.small}
                  buttonTextSize={buttonTextSizes.mediumSmall}
                  additionalStyles="no-margin margin-left-15"
                  disabled={pristine || invalid}
                />
              </div>
            </div>
          </form>
        )}
      />
    </React.Fragment>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    alertDeviceTypes: state.devices.alertDeviceTypes,
  };
};

export default connect(mapStateToProps)(UnconnectedAddEditMassNotification);